"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TCMTestClientFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_tcmImplementation",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_tokensToRegister",
                type: "address[]",
            },
            {
                internalType: "uint256",
                name: "_callerRewardRatio",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRewardRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRewardRatio",
                type: "uint256",
            },
        ],
        name: "CallerRewardChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address[][]",
                name: "paths",
                type: "address[][]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicAmount",
                type: "uint256",
            },
        ],
        name: "ConversionsPerformed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "ImplementationChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenDeregistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
        ],
        name: "TokenRegistered",
        type: "event",
    },
    {
        stateMutability: "nonpayable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "callerRewardBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "callerRewardRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "deregisterToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getRegisteredTokens",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[][]",
                name: "_paths",
                type: "address[][]",
            },
            {
                internalType: "uint256[]",
                name: "_amounts",
                type: "uint256[]",
            },
        ],
        name: "performConversionForTokens",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[][]",
                name: "_paths",
                type: "address[][]",
            },
        ],
        name: "performConversionForTokensFullBalance",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
        ],
        name: "registerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_callerRewardRatio",
                type: "uint256",
            },
        ],
        name: "setCallerRewardRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tcmImplementation",
                type: "address",
            },
        ],
        name: "setTcmImplementation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tcmImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "testEthAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "testVvsAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class TCMTestClientFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_tcmImplementation, _tokensToRegister, _callerRewardRatio, overrides) {
        return super.deploy(_tcmImplementation, _tokensToRegister, _callerRewardRatio, overrides || {});
    }
    getDeployTransaction(_tcmImplementation, _tokensToRegister, _callerRewardRatio, overrides) {
        return super.getDeployTransaction(_tcmImplementation, _tokensToRegister, _callerRewardRatio, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TCMTestClientFactory = TCMTestClientFactory;
TCMTestClientFactory.bytecode = _bytecode;
TCMTestClientFactory.abi = _abi;
//# sourceMappingURL=TCMTestClientFactory.js.map